import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import { auth } from '../firebase'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    redirect: "/au",
    meta: { transparentHeader: true },
    component: Home,
  },
  {
    path: '/login',
    name: 'Login',
    meta: { transparentHeader: true },
    component: () => import(  '../views/gmail_login')
  },
  {
    path: '/not-found',
    name: '404',
    component: () => import('../views/404')
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: () => import('../views/privacy_policy')
  },
  {
    path: '/terms-of-service',
    name: 'Terms of Service',
    component: () => import('../views/terms_of_service')
  },
  {
    path: '/facebook-delete-data',
    name: 'Facebook Delete Data',
    component: () => import('../views/terms_of_service')
  },
  {
    path: '/facebook-deauthorize',
    name: 'Facebook Deauthorize',
    component: () => import('../views/terms_of_service')
  },


  {
    name: 'Admin Dashboard',
    path: '/admin',
    meta: { requiresAuth: true },
    component: () => import('../views/admin/dashboard'),
    children: [
      {
        name: 'Sites',
        path: 'sites',
        component: () => import('../views/admin/view_group'),
        children:[
          {
            name: 'Sites',
            path: '',
            meta: { links: ['/admin/sites/new', '/admin/sites/import'] },
            component: () => import('../views/admin/sites/index'),
          },
          {
            name: 'Import Sites',
            path: 'import',
            meta: { links: ['/admin/sites/'] },
            component: () => import('../views/admin/sites/import'),
          },
          {
            name: 'Edit Site',
            path: ':document_id/edit',
            meta: { links: ['/admin/sites/'] },
            component: () => import('../views/admin/sites/edit'),
          },
          {
            name: 'Site Products',
            path: ':document_id/products',
            meta: { links: ['/admin/sites/'] },
            component: () => import('../views/admin/sites/site_products'),
          },
          {
            name: 'New Site',
            path: 'new',
            meta: { links: ['/admin/sites/'] },
            component: () => import('../views/admin/sites/new'),
          }
        ]
      },
      {
        name: 'Product Import',
        path: 'product_import',
        component: () => import('../views/admin/products/product_import')
      },
      {
        name: 'Unapproved Products',
        path: 'unapproved_products',
        component: () => import('../views/admin/view_group'),
        children:[
          {
            name: 'Unapproved Products',
            path: '',
            meta: { links: [] },
            component: () => import('../views/admin/products/unapproved_products'),
          }
        ]
      },
      {
        name: 'Approved Products',
        path: 'approved_products',
        component: () => import('../views/admin/view_group'),
        children:[
          {
            name: 'Approved Products',
            path: '',
            meta: { links: [] },
            component: () => import('../views/admin/products/approved_products'),
          }
        ]
      },
      {
        name: 'Rejected Products',
        path: 'rejected_products',
        component: () => import('../views/admin/view_group'),
        children:[
          {
            name: 'Rejected Products',
            path: '',
            meta: { links: [] },
            component: () => import('../views/admin/products/rejected_products'),
          }
        ]
      },
      {
        name: 'Social Posts',
        path: 'social_posts',
        component: () => import('../views/admin/view_group'),
        children: [
          {
            name: 'Social Posts',
            path: '',
            meta: { },
            component: () => import('../views/admin/socialposts/index')
          },
          {
            name: 'Edit Social Post',
            path: ':id',
            meta: { links: ['/admin/social_posts'] },
            component: () => import('../views/admin/socialposts/edit')
          }
        ]
      },
      {
        name: 'Categories',
        path: 'categories',
        component: () => import('../views/admin/categories/categories'),
      },
      {
        name: 'Pages',
        path: 'pages',
        component: () => import('../views/admin/view_group'),
        children: [
          {
            name: 'Pages',
            path: '',
            meta: { links: ['/admin/pages/new'] },
            component: () => import('../views/admin/pages/index')
          },
          {
            name: 'New Page',
            path: 'new',
            meta: { links: ['/admin/pages'] },
            component: () => import('../views/admin/pages/')
          },
          {
            name: 'Edit Page',
            path: ':id',
            meta: { links: ['/admin/pages'] },
            component: () => import('../views/admin/pages/')
          }
        ]
      }
    ]
  },


  {
    path: '/:post_id(\\d+)',
    name: 'Post',
    component: () => import('../views/store/layout'),
    children: [
      {
        path: '',
        name: 'Post',
        component: () => import('../views/store/post')
      }
    ]
  },

  {
    path: '/:region',
    name: 'Lovaue',
    component: () => import('../views/store/layout'),
    children: [
      {
        path: '',
        name: 'Latest',
        component: () => import('../views/store/latest')
      },
      {
        path: 'latest/products/:product_id',
        name: 'Latest Product',
        component: () => import('../views/store/latest')
      },
      {
        path: 'post/:post_id',
        name: 'Post',
        component: () => import('../views/store/post')
      },
      {
        path: 'post/:post_id/:product_id',
        name: 'Post Product',
        component: () => import('../views/store/post')
      },
      {
        path: 'categories/:category',
        name: 'Category',
        component: () => import('../views/store/category')
      },
      {
        path: 'categories/:category/products/:product_id',
        name: 'Product',
        component: () => import('../views/store/category') //import('../views/store/product')
      },
      {
        path: 'sites/:site',
        name: 'Site',
        component: () => import('../views/store/site')
      },
      {
        path: 'sites/:site/products/:product_id',
        name: 'Site Product',
        component: () => import('../views/store/site')
      }
    ]
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {

  console.log("to", to);

 // window.scrollTo(0, 0);
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth);
  if (!requiresAuth) {
    next();
  }else if(!auth.currentUser) {
    next('/login');
  } else {
    next();
    auth.currentUser.getIdTokenResult().then(token => {
      if (!token.claims.admin){
        next('/login');
      }
    })
  }
});

export default router
